import * as SupportigMessageService from "../../services/references";

export const getReferences: (productId: number) => Promise<unknown> = async (
	productId
) => {
	const data = await SupportigMessageService.getReferenceData(productId);
	if (!data) return null;
	return data;
};
